import invariant from 'invariant';
import { options as defaultI18nextOptions } from './i18n';
import { Config } from './typings';

function ensureArray(a: any): any[] {
  if (!Array.isArray(a)) {
    return [a];
  }

  return a;
}

function calcAllNS(projects: Config['starlingProjects']) {
  if (!projects) {
    return [];
  }

  if (projects.length === 1) {
    return projects[0].namespace;
  }

  return projects.reduce<string[]>((res, p) => {
    res = res.concat(
      ensureArray(p.namespace).map(n => `${p.projectName}_${n}`),
    );

    return res;
  }, []);
}

export default function resolveConfig(config: Config): Config {
  if (Array.isArray(config.starlingProjects)) {
    config.starlingProjects.forEach(project => {
      project.namespace = ensureArray(project.namespace);
      invariant(
        project.projectName && project.api_key && project.namespace,
        '`projectName, api_key, namespace` is required',
      );
    });
  }

  if (!config.starlingProjects) {
    config.starlingProjects = ensureArray({
      projectName: config.projectName,
      api_key: config.api_key,
      namespace: ensureArray(config.namespace || config.i18nOptions?.ns),
    });

    delete config.projectName;
    delete config.api_key;
    delete config.namespace;
  }

  const shouldSetDefaultNS = !config.i18nOptions?.defaultNS;

  config.i18nOptions = {
    ...defaultI18nextOptions,
    ...config.i18nOptions,
  };

  if (config.i18nOptions) {
    config.i18nOptions.ns = calcAllNS(config.starlingProjects);

    if (shouldSetDefaultNS) {
      config.i18nOptions.defaultNS = (config?.i18nOptions?.ns as string[])[0];
    }
  }

  return config;
}
